import type { Translated } from '@uefadigital/panenka';

import type { TeamInterestOptions, TeamInterestStatus } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';
import type { Team } from '@shared-types/match.types';

type TeamInterestStoreState = {
  teamId?: string;
  status?: TeamInterestStatus;
  team?: Translated<Team>;
  setTeamId: (value?: string) => void;
  setTeam: (value?: Translated<Team>) => void;
  setStatus: (status?: TeamInterestStatus) => void;
};

export const { OptionsProvider: TeamInterestOptionsProvider, useOptions: useTeamInterestOptions } =
  getOptionsProvider<TeamInterestOptions>();

const { Provider: TeamInterestStoreProvider, useStore: useTeamInterestStore } =
  zustandStoreFactory<TeamInterestStoreState>(
    (set) => ({
      team: null,
      teamId: null,
      status: 'download',
      setTeamId: (teamId) => set(() => ({ teamId }), false, 'setTeamId'),
      setStatus: (status) => set(() => ({ status }), false, 'setStatus'),
      setTeam: (team) => set(() => ({ team }), false, 'setTeam'),
    }),
    'teamInterest',
  );
export { TeamInterestStoreProvider };

export const useTeam = () => {
  const team = useTeamInterestStore((state) => state.team);
  const setTeam = useTeamInterestStore((state) => state.setTeam);
  const teamId = useTeamInterestStore((state) => state.teamId);
  const setTeamId = useTeamInterestStore((state) => state.setTeamId);
  const status = useTeamInterestStore((state) => state.status);
  const setStatus = useTeamInterestStore((state) => state.setStatus);

  return { team, teamId, status, setTeamId, setTeam, setStatus };
};
